import React from 'react';
import ParticipantPreparation from './ParticipantPreparation';
import './ReviewPreparationStep.styl';
import CoachingReviewTypeStore from 'stores/coaching/CoachingReviewTypeStore';
import classNames from 'classnames';
import connectToStores from 'alt-utils/lib/connectToStores';

class ReviewPreparationStep extends React.PureComponent {
  static title = 'Review Preparation';

  static validate(plan) {
    return {};
  }

  constructor(props) {
    super(props);

    this.onlyNoCallPlans = this.onlyNoCallPlans.bind(this);
  }

  static getStores() {
    return [CoachingReviewTypeStore];
  }

  static getPropsFromStores() {
    const store = CoachingReviewTypeStore.getState();
    return {
      types: store.types,
    };
  }

  onlyNoCallPlans() {
    const {model: coachingPlan, types} = this.props;

    const attachedTypes = coachingPlan.reviewTypeIds.map(id => types.get(id));

    return !attachedTypes.some(t => t.includesCalls);
  }

  componentDidMount() {
    const {onChange, model: coachingPlan} = this.props;

    const noParticipationPlan = coachingPlan
      .set(
        'coach',
        coachingPlan.coach
          .set('prepNumberOfCalls', 0)
          .set('prepShouldComment', false)
          .set('prepShouldScore', false)
      )
      .set(
        'recipient',
        coachingPlan.recipient
          .set('prepNumberOfCalls', 0)
          .set('prepShouldComment', false)
          .set('prepShouldScore', false)
      );

    if (this.onlyNoCallPlans()) {
      onChange(noParticipationPlan);
    }
  }

  render() {
    const {model: coachingPlan, onChange} = this.props;

    const onlyNoCallPlans = this.onlyNoCallPlans();

    return (
      <div className="coaching-step review-preparation">
        {onlyNoCallPlans ? (
          <p>
            You've indicated that this plan shouldn't support call focused sessions. We won't ask
            the coach or recipient to prep calls, score, or review.
          </p>
        ) : (
          <p>What preparation is necessary before each meeting?</p>
        )}

        <div className={classNames(['form-body', onlyNoCallPlans && 'disable'])}>
          <div className="preparation-item">
            <h3>Coach</h3>
            <ParticipantPreparation
              preparation={coachingPlan.coach}
              onChange={preparation => onChange(coachingPlan.set('coach', preparation))}
              disabled={onlyNoCallPlans}
              min={0}
            />
          </div>
          <div className="preparation-item">
            <h3>Recipient</h3>
            <ParticipantPreparation
              preparation={coachingPlan.recipient}
              onChange={preparation => onChange(coachingPlan.set('recipient', preparation))}
              disabled={onlyNoCallPlans}
              min={0}
            />
          </div>
        </div>
      </div>
    );
  }
}

const connectedComponent = connectToStores(ReviewPreparationStep);
connectedComponent.title = ReviewPreparationStep.title;
connectedComponent.validate = ReviewPreparationStep.validate;
connectedComponent.shouldDisplay = ReviewPreparationStep.shouldDisplay;
export default connectedComponent;
